import { useState } from "react";
import { useDispatch } from "react-redux";
import InputText from "../../../components/Input/InputText";
import ErrorText from "../../../components/Typography/ErrorText";
import { showNotification } from "../../common/headerSlice";
import api from "../../../utils/axios";
import { triggerRefresh } from "../../../utils/refreshRegistry";

function EditServiceRoleModalBody({ closeModal, extraObject }) {
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState("");
  const [roleObj, setRoleObj] = useState({
    name: extraObject?.name || "",
    serviceId: extraObject?.serviceId || "",
  });
  const [saving, setSaving] = useState(false);

  const saveRole = async () => {
    if (!roleObj.name.trim()) {
      setErrorMessage("Role name is required!");
      return;
    }
    if (!roleObj.serviceId) {
      setErrorMessage("Service is required!");
      return;
    }

    setSaving(true);
    setErrorMessage("");

    try {
      await api.put(`/api/service-roles/${extraObject.id}`, {
        name: roleObj.name.trim(),
        serviceId: roleObj.serviceId,
      });
      dispatch(showNotification({ message: "Service Role Updated!", status: 1 }));
      closeModal();
      triggerRefresh("service-roles");
    } catch (error) {
      console.error("Error updating service role:", error);
      const errorMsg =
        error.response?.data?.message ||
        "Failed to update service role. Please try again.";
      setErrorMessage(errorMsg);
      dispatch(showNotification({ message: errorMsg, status: 0 }));
    } finally {
      setSaving(false);
    }
  };

  const updateFormValue = ({ updateType, value }) => {
    setErrorMessage("");
    setRoleObj({ ...roleObj, [updateType]: value });
  };

  return (
    <>
      <InputText
        type="text"
        defaultValue={roleObj.name}
        updateType="name"
        containerStyle="mt-4"
        labelTitle="Role Name"
        placeholder="e.g. Song Leader, Pianist"
        updateFormValue={updateFormValue}
      />

      <div className="form-control w-full mt-4">
        <label className="label">
          <span className="label-text">Service</span>
        </label>
        <select
          className="select select-bordered w-full"
          value={roleObj.serviceId}
          onChange={(e) => updateFormValue({ updateType: "serviceId", value: e.target.value })}
        >
          <option value="">Select a service...</option>
          {extraObject?.services?.map((svc) => (
            <option key={svc.id} value={svc.id}>
              {svc.serviceType} ({svc.dayOfWeek})
            </option>
          ))}
        </select>
      </div>

      <ErrorText styleClass="mt-4">{errorMessage}</ErrorText>
      <div className="modal-action">
        <button className="btn btn-ghost" onClick={() => closeModal()}>
          Cancel
        </button>
        <button
          className="btn btn-primary px-6"
          onClick={saveRole}
          disabled={saving}
        >
          {saving ? (
            <>
              <span className="loading loading-spinner loading-sm"></span>
              Saving...
            </>
          ) : (
            "Save"
          )}
        </button>
      </div>
    </>
  );
}

export default EditServiceRoleModalBody;